/// <amd-module name="SuiteCommerce.GiftCertificate.Utils"/>
define("SuiteCommerce.GiftCertificate.Utils", ["require", "exports", "SuiteCommerce.GiftCertificate.Main.Configuration"], function (require, exports, Main_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = void 0;
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.formatDate = function (receivedDate) {
            var newDate = Main_Configuration_1.MainConfiguration.dateFormat;
            var monthReplaced = false;
            var date = new Date(receivedDate);
            var replaceMonth = function (monthLength, format) {
                var matched = newDate.match(monthLength);
                if (matched && !monthReplaced) {
                    monthReplaced = true;
                    return newDate.replace(monthLength, date.toLocaleString('en-us', format));
                }
                return newDate;
            };
            var ua = navigator.userAgent;
            var isOldIe = ua.indexOf('MSIE ') > -1;
            if (isOldIe) {
                return receivedDate;
            }
            newDate = newDate.replace('yyyy', date.toLocaleString('en-us', { year: 'numeric' }));
            newDate = newDate.replace('yy', date.toLocaleString('en-us', { year: '2-digit' }));
            newDate = newDate.replace('dd', date.toLocaleString('en-us', { day: '2-digit' }));
            newDate = newDate.replace('d', date.toLocaleString('en-us', { day: 'numeric' }));
            newDate = replaceMonth('mmmm', { month: 'long' });
            newDate = replaceMonth('mmm', { month: 'short' });
            newDate = replaceMonth('mm', { month: '2-digit' });
            newDate = replaceMonth('m', { month: 'numeric' });
            return newDate;
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
